var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6309 50.8877H52.2624V53.6375H40.6309V50.8877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88337 68.7827C4.8713 62.0513 2.75081 54.3277 2.75081 46.4467C2.75081 34.7755 7.29654 23.8024 15.5496 15.5486C23.8034 7.29557 34.7765 2.74984 46.4477 2.74984C53.9835 2.74984 61.4116 4.69882 67.9304 8.38629L69.2841 5.99294C62.3535 2.0723 54.4569 0 46.4477 0C34.0422 0 22.3781 4.83135 13.6056 13.6046C4.83232 22.3771 0.000976562 34.0406 0.000976562 46.4467C0.000976562 54.8224 2.25612 63.0329 6.5212 70.191C10.663 77.14 16.5723 82.9182 23.6113 86.8998L24.9657 84.5064C18.342 80.7601 12.7813 75.3228 8.88337 68.7827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7196 25.1221C84.4446 18.7961 79.6713 13.2178 73.9158 8.99023L72.2879 11.2064C77.7039 15.1852 82.1958 20.4339 85.2773 26.3865C88.5069 32.6239 90.1441 39.3731 90.1441 46.4468C90.1441 58.118 85.5991 69.0911 77.3453 77.3449C69.0923 85.5987 58.1184 90.1437 46.4472 90.1437C40.0489 90.1437 33.8837 88.7929 28.1233 86.1281L26.9688 88.6235C33.0935 91.4569 39.647 92.8935 46.4472 92.8935C58.8534 92.8935 70.5168 88.0622 79.29 79.2889C88.0626 70.5164 92.8939 58.853 92.8939 46.4468C92.8939 39.035 91.1051 31.6608 87.7196 25.1221Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8147 42.085H61.0648V59.6116H44.9932V62.3615H63.8147V42.085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8139 30.5327H29.0781V62.3613H40.6303V59.6115H31.828V33.2825H40.7096V47.8219H52.1831V33.2825H61.0641V37.7234H63.8139V30.5327ZM43.4595 45.0721V42.0062H49.4333V45.0721H43.4595ZM49.4333 39.2564H43.4595V33.2825H49.4333V39.2564Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6582 13.4876L41.6029 15.4323L45.0714 11.9639V20.2757H47.8212V11.9639L51.2897 15.4323L53.2345 13.4876L46.4463 6.7002L39.6582 13.4876Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2345 79.4058L51.2897 77.4611L47.8212 80.9295V72.6177H45.0714V80.9295L41.6029 77.4611L39.6582 79.4058L46.4463 86.1932L53.2345 79.4058Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2757 45.0719H11.9639L15.4323 41.6034L13.4883 39.6587L6.7002 46.4468L13.4883 53.2349L15.4323 51.2902L11.9639 47.8217H20.2757V45.0719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6172 47.8217H80.9291L77.4606 51.2902L79.4053 53.2349L86.1927 46.4468L79.4053 39.6587L77.4606 41.6034L80.9291 45.0719H72.6172V47.8217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9999 71.2428H23.5959L28.5187 66.32L26.574 64.3753L21.6512 69.298V63.894H18.9014V73.9926H28.9999V71.2428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8945 21.6507H69.2985L64.3765 26.5735L66.3205 28.5175L71.2433 23.5954V28.9994H73.9931V18.9009H63.8945V21.6507Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9999 18.9011H18.9014V28.9997H21.6512V23.5957L26.574 28.5177L28.5187 26.5737L23.5959 21.651H28.9999V18.9011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8945 73.9926H73.9931V63.894H71.2433V69.298L66.3205 64.3753L64.3765 66.32L69.2985 71.2428H63.8945V73.9926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1846 50.8877H26.0917V53.6375H23.1846V50.8877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1846 39.2561H26.0917V42.0059H23.1846V39.2561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8018 39.2561H69.7096V42.0059H66.8018V39.2561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8018 50.8877H69.7096V53.6375H66.8018V50.8877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8096 66.8804H53.7175V69.6302H50.8096V66.8804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1768 66.8804H42.0846V69.6302H39.1768V66.8804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1768 23.2632H42.0846V26.013H39.1768V23.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8096 23.2632H53.7175V26.013H50.8096V23.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9932 23.2632H47.901V26.013H44.9932V23.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.625 23.2629H59.5322V26.0128H56.625V23.2629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3623 23.2632H36.2702V26.013H33.3623V23.2632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3623 66.8804H36.2702V69.6302H33.3623V66.8804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9932 66.8804H47.901V69.6302H44.9932V66.8804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.625 66.8804H59.5322V69.6302H56.625V66.8804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8018 56.7034H69.7096V59.4532H66.8018V56.7034Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8018 45.072H69.7096V47.8219H66.8018V45.072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8018 33.4404H69.7096V36.1903H66.8018V33.4404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1846 33.4404H26.0917V36.1903H23.1846V33.4404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1846 45.072H26.0917V47.8219H23.1846V45.072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1846 56.7034H26.0917V59.4532H23.1846V56.7034Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.8936,
    height: 92.8936,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.77d8345f1bac7e04a3ce82628131f84f.svg";
export { ForwardRef as ReactComponent };